import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CallCenterDevice, Spinner } from "@madmedical/ui";
import { invariant } from "@madmedical/utils";
import { adaptPatient, useGetPatientQuery } from "@madmedical/user";
import { skipToken } from "@madmedical/store";
import { useParams } from "@madmedical/routing";
import { useState } from "react";
import adaptDevice from "./adaptDevice";
import { useGetLogisticsDeviceQuery } from "./api";
import UpdateDeviceForm from "./UpdateDeviceForm";
var Modal;
(function (Modal) {
    Modal[Modal["Closed"] = 0] = "Closed";
    Modal[Modal["Edit"] = 1] = "Edit";
})(Modal || (Modal = {}));
const Device = () => {
    var _a;
    const { deviceId } = useParams();
    invariant(deviceId);
    const { data: device, isLoading } = useGetLogisticsDeviceQuery(deviceId);
    const { data: patient } = useGetPatientQuery((_a = device === null || device === void 0 ? void 0 : device.patientId) !== null && _a !== void 0 ? _a : skipToken);
    const [modal, setModal] = useState(Modal.Closed);
    const handleEditPress = () => {
        setModal(Modal.Edit);
    };
    const handleModalClose = () => {
        setModal(Modal.Closed);
    };
    if (isLoading) {
        return _jsx(Spinner, {});
    }
    invariant(device);
    return (_jsxs(_Fragment, { children: [_jsx(CallCenterDevice, { device: adaptDevice(device), patient: patient ? adaptPatient(patient) : undefined, onEditPress: handleEditPress }), _jsx(UpdateDeviceForm, { id: deviceId, open: modal === Modal.Edit, onClose: handleModalClose })] }));
};
export default Device;
